import React from 'react';

export const MasterCardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.56689 16.8244H14.4337V8.17627H9.56689V16.8244Z"
      fill="#FF5F00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.87522 12.5C9.87522 10.7455 10.7061 9.18304 11.9998 8.17593C11.0537 7.43939 9.85977 7 8.56214 7C5.49035 7 3 9.46247 3 12.5C3 15.5375 5.49035 18 8.56214 18C9.85977 18 11.0537 17.5606 11.9998 16.8241C10.7061 15.817 9.87522 14.2545 9.87522 12.5Z"
      fill="#EB001B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8261 15.9084V15.6948H20.7697L20.7045 15.8418L20.6394 15.6948H20.5829V15.9084H20.6229V15.7474L20.6838 15.8861H20.7252L20.7862 15.7471V15.9084H20.8261ZM20.4691 15.9079V15.7309H20.5415V15.6948H20.357V15.7309H20.4294V15.9079H20.4691ZM20.9998 12.5C20.9998 15.5375 18.5096 18 15.4377 18C14.1401 18 12.9463 17.5606 12 16.8241C13.2938 15.817 14.1246 14.2545 14.1246 12.5C14.1246 10.7455 13.2938 9.18304 12 8.17593C12.9463 7.43939 14.1401 7 15.4377 7C18.5096 7 20.9998 9.46247 20.9998 12.5Z"
      fill="#F79E1B"
    />
  </svg>
);
